import { action } from 'typesafe-actions';
import { categoriesTypes } from './types';

export const searchCategoriesRequest = requestParams => action(categoriesTypes.SEARCH_CATEGORIES_REQUEST, requestParams);

export const searchCategoriesRequestSuccess = ({
  payload: data, pagination,
}) => action(categoriesTypes.SEARCH_CATEGORIES_REQUEST_SUCCESS, {
  data, pagination,
});

export const searchFirstCategoriesRequestSuccess = ({
  payload: data, pagination,
}) => action(categoriesTypes.SEARCH_FIRST_CATEGORIES_REQUEST_SUCCESS, {
  data, pagination,
});

export const searchCategoriesRequestFailure = () => action(categoriesTypes.SEARCH_CATEGORIES_REQUEST_FAILURE);
export const updateFilterParams = payload => action(categoriesTypes.UPDATE_CATEGORY_FILTER_PARAMS, payload);
export const changeFilterModalStatus = active => action(categoriesTypes.CHANGE_CATEGORY_FILTER_MODAL_STATUS, active);

export const activateInactivateCategoriesRequest = payload => action(categoriesTypes.ACTIVATE_INACTIVATE_CATEGORIES_REQUEST, payload);
export const activateInactivateCategoriesSuccess = () => action(categoriesTypes.ACTIVATE_INACTIVATE_CATEGORIES_SUCCESS);
export const activateInactivateCategoriesFailure = () => action(categoriesTypes.ACTIVATE_INACTIVATE_CATEGORIES_FAILURE);

export const saveCategoryRequest = payload => action(categoriesTypes.SAVE_CATEGORY_REQUEST, payload);
export const saveCategoryRequestResponse = response => action(categoriesTypes.SAVE_CATEGORY_REQUEST_RESPONSE, response);
export const setEditCategory = category => action(categoriesTypes.SET_EDIT_CATEGORY, category);
export const clearEditCategory = () => action(categoriesTypes.CLEAR_EDIT_CATEGORY);
export const clearEditCategoryStepper = () => action(categoriesTypes.CLEAR_EDIT_CATEGORY_STEPPER);
